import NewCustInfo from 'src/components/NewCustInfo/NewCustInfo';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, CustomerActionCreator, VehiclesActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    customerInfo: state.Customer,
    custError: state.Customer.errMsg,
    custInfo: state.Customer.Customer,
    profile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    apptCust: state.Appointment.ApptCust,
    apptVeh: state.Appointment.ApptVeh,
    decodedData: state.Vehicles.decodedData,
    oemFirstName: state.Framework.oemFirstName,
    oemLastName: state.Framework.oemLastName,
    gmRewardsEligible: state.Specs.specs?.gmDealerCanRedeem,
    gmMemberErr: state.Customer.gmMemberErr,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    transFlag: state.Appointment.Appointment.transFlag,
    gmossVersion: state.Framework.gmossVersion ?? '',
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
    theme: state.Framework.theme,
    sessionId: state.Framework.sessionId,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    specData: state.Specs,
    appointment: state.Appointment,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    updateApptCust: AppointmentActionCreator.UpdateApptCust,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    checkUniqueEmail: CustomerActionCreator.CheckUniqueEmail,
    clearCustError: CustomerActionCreator.CustomerClearError,
    decodeVin: VehiclesActionCreator.DecodeVin,
    clearDecoded: VehiclesActionCreator.ClearDecodeData,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewCustInfo);